import React, {Component} from 'react';
import AppNavigation from './AppNavigation';
import AppFooter from './AppFooter';
import SubEditAssessment from './Subcomponents/EditAssessment';
import withRouter from './Functions/WithRouter';

class AdvEditAssessment extends Component {
    constructor(props) {
      super(props)

      this.state = {
      }
    }

    componentDidMount(){
      document.body.style.backgroundColor = "rgba(178,186,191,0.2)";

      let email = localStorage.getItem('email');
      let roleName = localStorage.getItem('roleName');
      let username = localStorage.getItem('username');
      let activeOrg = localStorage.getItem('activeOrg');
      let orgFocus = localStorage.getItem('orgFocus');
      const orgLogo = localStorage.getItem('orgLogo');

      if (email) {

        let assessmentId = null
        if (this.props.params && this.props.params.id) {
          assessmentId = this.props.params.id
        }
        let selectedTemplate = null
        let duplicate = null
        if (this.props.location && this.props.location.state && this.props.location.state.selectedTemplate) {
          selectedTemplate = this.props.location.state.selectedTemplate
          duplicate = this.props.location.state.duplicate
        }

        this.setState({ activeOrg, emailId: email, username, orgFocus, roleName, orgLogo,
          assessmentId, selectedTemplate, duplicate
        })

      }

      if (window.innerWidth > 768) {

          setTimeout(() => {
              this.setState(state => ({
                  opacity: 1,
                  transform: 'translate(2%)'
                }));
          }, 0.3)

      } else {

          setTimeout(() => {
              this.setState(state => ({
                  opacity: 1,
                  transform: 'translate(2%)'
                }));
          }, 0.3)

      }
    }


    render() {

      return (
        <div>
          <AppNavigation username={this.state.username} fromAdvisor={true} activeOrg={this.state.activeOrg} orgFocus={this.state.orgFocus} roleName={this.state.roleName} history={this.props.navigate} />

          <SubEditAssessment activeOrg={this.state.activeOrg} assessmentId={this.state.assessmentId} selectedTemplate={this.state.selectedTemplate} duplicate={this.state.duplicate} />

          {(this.state.activeOrg) && (
            <div>
              {AppFooter(this.props.navigate,this.state.activeOrg,this.state.orgLogo)}
            </div>
          )}
        </div>
      )
    }
}

export default withRouter(AdvEditAssessment);
